import { ApiService } from '../../../shared/services/api.service';
import { OccupiedRoom } from '../model/types';

export const updateSelfUserPresence = async (
  floorPid: string,
  roomPid: string
): Promise<OccupiedRoom[]> => {
  return ApiService.request({
    method: 'POST',
    endpoint: `office/floor/${floorPid}/presence`,
    data: { room_pid: roomPid },
  });
};
